import { MainV3ApiBase } from './base';

export const ShownUserTutorialApis = {
    base() {
        return MainV3ApiBase.appendPath('users/current/shown_user_tutorials');
    },
    shownTutorials(): Promise<boolean> {
        return this.base().get();
    },
};
